import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../Login.css';
import logo from '../../assets/img.png';
import axiosInstance from "../../api/axiosConfig.jsx";

const Register = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    const [isValidToken, setIsValidToken] = useState(null);
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        phoneNumber: '',
        dateOfBirth: '',
        address: '',
        email: '',
        socialSecurityNumber: '',
    });
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [language, setLanguage] = useState('nl');

    // Validate token when the page loads
    useEffect(() => {
        const validateToken = async () => {
            try {
                const response = await axiosInstance.get(`/employees/register/${token}`);
                if (response.status === 200) {
                    setIsValidToken(true);
                }
            } catch (error) {
                setIsValidToken(false);
            }
        };
        validateToken();
    }, [token]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setSuccess(null);

        if (!formData.address) {
            setError(language === 'nl' ? 'Vul het adres in.' : 'Please enter the address.');
            return;
        }

        try {
            const response = await axiosInstance.post(`/employees/register/${token}`, formData);
            if (response.status === 200) {
                setSuccess(language === 'nl' ? 'Werknemer succesvol geregistreerd!' : 'Employee registered successfully!');
                setTimeout(() => {
                    navigate('/login');
                }, 3000); // Redirect after 3 seconds
            }
        } catch (error) {
            setError(language === 'nl' ? 'Fout bij het registreren van de werknemer.' : 'Error registering employee.');
        }
    };

    const toggleLanguage = () => {
        setLanguage((prevLanguage) => (prevLanguage === 'nl' ? 'en' : 'nl'));
    };

    const getPlaceholder = (key) => {
        const placeholders = {
            nl: {
                firstName: 'Voer je voornaam in',
                lastName: 'Voer je achternaam in',
                phoneNumber: 'Voer je telefoonnummer in',
                dateOfBirth: 'Voer je geboortedatum in',
                address: 'Voer je adres in',
                email: 'Voer je e-mailadres in',
                socialSecurityNumber: 'Voer je burgerservicenummer in',
            },
            en: {
                firstName: 'Enter your first name',
                lastName: 'Enter your last name',
                phoneNumber: 'Enter your phone number',
                dateOfBirth: 'Enter your date of birth',
                address: 'Enter your address',
                email: 'Enter your email',
                socialSecurityNumber: 'Enter your social security number',
            }
        };
        return placeholders[language][key];
    };

    const getFieldLabel = (key) => {
        const labels = {
            firstName: language === 'nl' ? 'Voornaam' : 'First Name',
            lastName: language === 'nl' ? 'Achternaam' : 'Last Name',
            phoneNumber: language === 'nl' ? 'Telefoonnummer' : 'Phone Number',
            dateOfBirth: language === 'nl' ? 'Geboortedatum' : 'Date of Birth',
            address: language === 'nl' ? 'Adres' : 'Address',
            email: language === 'nl' ? 'E-mail' : 'Email',
            socialSecurityNumber: language === 'nl' ? 'Burgerservicenummer' : 'Social Security Number',
        };
        return labels[key];
    };

    if (isValidToken === false) {
        return (
            <div className="container mt-5">
                <div className="alert alert-danger text-center">
                    <h4 className="alert-heading">{language === 'nl' ? 'Ongeldige of Verlopen Link' : 'Invalid or Expired Link'}</h4>
                    <p>{language === 'nl' ? 'Deze registratie link is ongeldig of is verlopen. Neem contact op met de ondersteuning.' : 'This registration link is either invalid or has expired. Please contact support.'}</p>
                </div>
            </div>
        );
    }

    return (
        <div className="container-fluid vh-100 d-flex justify-content-center align-items-center" style={{ backgroundColor: '#f8f9fa', minHeight: '100vh', minWidth: '100vw' }}>
            <div className="card shadow-lg p-4" style={{ maxWidth: '400px', width: '100%', borderRadius: '15px', backgroundColor: '#ffffff', maxHeight: '90vh', overflowY: 'auto' }}>
                <div className="text-center mb-4">
                    <img src={logo} alt="HorecaMasters Logo" style={{ maxWidth: '250px', height: '130px' }} />
                </div>
                <h2 className="text-center mb-4" style={{ fontSize: '1.5rem', color: '#343a40' }}>
                    {language === 'nl' ? 'Werknemer Registratie' : 'Employee Registration'}
                </h2>

                {error && <div className="alert alert-danger">{error}</div>}
                {success && <div className="alert alert-success">{success}</div>}

                <form onSubmit={handleSubmit}>
                    {Object.keys(formData).map((key) => (
                        <div className="mb-3" key={key}>
                            <label htmlFor={key} className="form-label mt-1">{getFieldLabel(key)}</label>
                            <div className="input-group">
                                <span className="input-group-text">
                                    <i className={`fas ${key === 'email' ? 'fa-envelope' : 'fa-user'}`}
                                       style={{color: '#495057'}}></i>
                                </span>
                                <input
                                    type={key === 'dateOfBirth' ? 'date' : 'text'}
                                    className="form-control"
                                    id={key}
                                    name={key}
                                    value={formData[key]}
                                    onChange={handleChange}
                                    placeholder={getPlaceholder(key)}
                                    required={key !== 'socialSecurityNumber'}
                                />
                            </div>
                        </div>
                    ))}
                    <button type="submit" className="btn btn-success w-100">{language === 'nl' ? 'Registreer Werknemer' : 'Register Employee'}</button>
                </form>

                <div className="form-check form-switch mt-3 text-center">
                    <input className="form-check-input" type="checkbox" id="languageSwitch" onChange={toggleLanguage} checked={language === 'en'} />
                    <label className="form-check-label" htmlFor="languageSwitch">
                        {language === 'nl' ? 'Schakel naar Engels' : 'Switch to Dutch'}
                    </label>
                </div>
            </div>
        </div>
    );
};

export default Register;
